// Support actions - API calls for support center
import axios from "axios";

const SERVER = import.meta.env.VITE_API_URL || "https://api.travelprym.in";
const API_PREFIX = "/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem("prima_session");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

// ==================== TICKET OPERATIONS ====================

// Get all tickets with filters
export const fetchTickets = async (filters = {}) => {
  const token = localStorage.getItem("prima_session");
  if (!token) throw new Error("Token not found");

  const params = {
    ...filters,
  };

  const queryString = new URLSearchParams(params).toString();
  const url = `${SERVER}${API_PREFIX}/support/tickets?${queryString}`;

  const res = await axios.get(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Get single ticket by ID
export const fetchTicketById = async (ticketId) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}`;

  const res = await axios.get(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Create new ticket
export const createTicket = async (ticketData) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets`;
  console.log("Creating ticket with data:", ticketData);
  const res = await axios.post(url, ticketData, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Update ticket
export const updateTicket = async (ticketId, updateData) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}`;

  const res = await axios.patch(url, updateData, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Assign ticket to admin
export const assignTicket = async (ticketId, adminId) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}/assign`;

  const res = await axios.post(url, { adminId }, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Close ticket
export const closeTicket = async (ticketId) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}/close`;

  const res = await axios.post(url, {}, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Delete ticket (soft delete)
export const deleteTicket = async (ticketId) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}`;

  const res = await axios.delete(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// ==================== COMMENT OPERATIONS ====================

// Get comments for a ticket
export const fetchComments = async (ticketId) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}/comments`;

  const res = await axios.get(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Add comment to ticket
export const addComment = async (ticketId, commentData) => {
  const url = `${SERVER}${API_PREFIX}/support/tickets/${ticketId}/comments`;

  const res = await axios.post(url, commentData, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Delete comment
export const deleteComment = async (commentId) => {
  const url = `${SERVER}${API_PREFIX}/support/comments/${commentId}`;

  const res = await axios.delete(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// ==================== FAQ OPERATIONS ====================

// Get all FAQs
export const fetchFaqs = async (category = "") => {
  const params = category ? { category } : {};
  const queryString = new URLSearchParams(params).toString();
  const url = `${SERVER}${API_PREFIX}/support/faqs?${queryString}`;

  const res = await axios.get(url, {
    withCredentials: true,
  });

  return res.data;
};

// Get FAQ categories
export const fetchFaqCategories = async () => {
  const url = `${SERVER}${API_PREFIX}/support/faqs/categories`;

  const res = await axios.get(url, {
    withCredentials: true,
  });

  return res.data;
};

// Create FAQ
export const createFaq = async (faqData) => {
  const url = `${SERVER}${API_PREFIX}/support/faqs`;

  const res = await axios.post(url, faqData, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Update FAQ
export const updateFaq = async (faqId, faqData) => {
  const url = `${SERVER}${API_PREFIX}/support/faqs/${faqId}`;

  const res = await axios.patch(url, faqData, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Delete FAQ
export const deleteFaq = async (faqId) => {
  const url = `${SERVER}${API_PREFIX}/support/faqs/${faqId}`;

  const res = await axios.delete(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// ==================== ADMIN OPERATIONS ====================

// Get all admin users for assignment (optionally filtered by role)
export const fetchAdminUsers = async (roleId = "") => {
  const params = roleId ? { roleId } : {};
  const queryString = new URLSearchParams(params).toString();
  const url = `${SERVER}${API_PREFIX}/support/admins?${queryString}`;

  const res = await axios.get(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};

// Get all roles for assignment dropdown
export const fetchRoles = async () => {
  const url = `${SERVER}${API_PREFIX}/support/roles`;

  const res = await axios.get(url, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });

  return res.data;
};
